import store from '@ps/store'
import { Buffer } from 'buffer'
import {
  AssetRoute,
  AssetType,
  builtinScript,
  GamePage,
  ImageType,
} from '@ps/utils/config'
import { moveFile, readFile, updateVar } from '@ps/api/editor/file'
import { Base64 } from 'js-base64'
import { createComponent } from '@ps/api/asset'
import * as utils from '@ps/bridge/qc/base'
import * as text from '@ps/bridge/qc/node/text'
import { saveGlobalUrlMap } from '@ps/bridge/resource/global-url-map'
import router from '@ps/router'
import { getIframe } from '@ps/bridge/iframe/iframe'
import { saveFile } from '@ps/api/editor/file'

export const isUUID = (string) => {
  if (/^\[object String\]$/.test(Object.prototype.toString.call(string))) {
    return /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(
      string,
    )
  }
  return false
}

export const isVPComponent = (string) => {
  if (/^\[object String\]$/.test(Object.prototype.toString.call(string))) {
    return /^ps.VPComponent_/.test(string)
  }
  return false
}

export const getParent = (page, scene) => {
  const game = store.state.workspace.game
  let parent
  if (page === GamePage.ENDING) {
    parent = game.data.gameOb.world.children[0]._findByName(
      GamePage.END_NODE_NAME,
    )
  } else if (page === GamePage.START) {
    parent = game.data.gameOb.world.children[0]._findByName(
      GamePage.START_NODE_NAME,
    )
  } else {
    if (!scene) {
      parent = game.data.gameOb.world.children[0]._findByName(GamePage.GAMEPLAY)
    } else {
      parent = game.data.gameOb.world.children[0]
        ._findByName(GamePage.GAMEPLAY)
        .children.find((item) => {
          return item.uuid === scene
        })
    }
  }
  return parent
  // if (!game.activeNode) {
  //   return game.data.gameOb.world
  // }
  // if (game.activeNode) {
  //   if (game.activeNode.class !== 'qc.UIText' && game.activeNode.class !== 'qc.Sprite') {
  //     return game.activeNode
  //   } else {
  //     let node = game.activeNode
  //     while (node !== game.data.gameOb.world && node.class !== 'qc.UIRoot') {
  //       node = node.parent
  //     }
  //     if (node.class === 'qc.UIRoot') {
  //       return node
  //     }
  //     return game.data.gameOb.world
  //   }
  // }
}
export const getUIRoot = () => {
  const game = store.state.workspace.game
  return game.data.gameOb.world.children[0]
}

export const generateUUID = () => {
  const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = chars.length
  let str = ''
  for (let i = 0; i < 12; i++) {
    str += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  let num = (new Date().getTime() % 1000).toString()
  if (num.length === 1) {
    num = '00' + num
  } else if (num.length === 2) {
    num = '0' + num
  }
  return str + num
}

export const getExt = (n) => {
  if (n.indexOf('.') < 0) {
    return n
  }
  return n.slice(n.lastIndexOf('.') + 1)
}

export const getBinName = (n) => {
  return n.slice(0, n.lastIndexOf('.')) + '.bin'
}

export const getFileName = (n) => {
  return n.slice(n.lastIndexOf('/') + 1)
}

export const getFileNameWithoutExt = (n) => {
  const name = n.slice(n.lastIndexOf('/') + 1)
  if (name.indexOf('.') < 0) {
    return name
  }
  return name.split('.')[0]
}

/**
 * 将多个文件内容合并一起，用 buffer 方式组合在一起
 * @param {string[]} arguments - 各个文件的内容
 */
export const packBinary = (compressType, pieces) => {
  const arr = []
  // 将所有的文件先串在一起，内存中的结果将形如：
  // 00 00 00 00 00 00 00 00 00 00 .. 00 00 00 00 00 00 00 ..
  // -----------|--------------------|-----------|-----------
  //   a lenth       a content          b length     b content ..
  for (let i = 0, len = pieces.length; i < len; i++) {
    let body = pieces[i]
    body = Buffer.from(body)
    // 长度记录
    const bodyLenInt = body.length
    const bodyLen = Buffer.alloc(4)
    bodyLen[0] = (bodyLenInt >> 24) & 0xff
    bodyLen[1] = (bodyLenInt >> 16) & 0xff
    bodyLen[2] = (bodyLenInt >> 8) & 0xff
    bodyLen[3] = bodyLenInt & 0xff
    arr.push(bodyLen, body)
  }
  if (compressType === 'CONCAT') {
    // 只连接不进行压缩，插入 magic number QC
    arr.unshift(Buffer.from('QC'))
    return Buffer.concat(arr)
  }
}

export const validateImage = (fileName) => {
  return ImageType.indexOf(getExt(fileName)) >= 0
}

export const validateAnimation = (files) => {
  if (files.length !== 3) {
    return false
  }
  const count = {
    ani: 0,
    img: 0,
    json: 0,
  }
  files.forEach((item) => {
    if (validateImage(item.name)) {
      count['img']++
    } else {
      count[getExt(item.name)]++
    }
  })
  if (count.ani === 1 && count.img === 1 && count.json === 1) {
    return true
  }
  return false
}

export function transformColorFormat(Color) {
  return `rgba(${Color.rgb.join(',')}, ${Color.alpha})`
}

// 解析出图集的依赖项，原图或json, png, ani
export async function parseAtlasDependece(binName, binContent, newUUID, path) {
  const projectKey = router.currentRoute.query.id
  if (binContent.length === 0) return []
  const binContent0 = JSON.parse(binContent[0])
  if (binContent0.type !== AssetType.ASSET_ATLAS) return []
  binContent0.uuid = newUUID
  const _binContent = []
  _binContent.push(JSON.stringify(binContent0))
  _binContent.push(binContent[1])
  _binContent.push(binContent[2])
  let imgBase64 = binContent[2]
  if (imgBase64 === '') {
    imgBase64 = await readFile({
      pid: projectKey,
      path: path.replace(/\.bin$/, binContent0.source[0]),
      base64: 1,
    })
    _binContent[2] = ''
  }
  if (binContent0.source.length === 1) {
    return [
      {
        name: binName + '.bin', // bin文件
        data: Base64.encode(JSON.stringify(_binContent)),
      },
      {
        name: binName + binContent0.source[0],
        data: imgBase64, // 图片base64
      },
    ]
  } else if (binContent0.source.length === 3) {
    _binContent.push(binContent[3])
    return [
      {
        name: binName + '.bin', // bin文件
        data: Base64.encode(JSON.stringify(_binContent)),
      },
      {
        name: binName + binContent0.source[0],
        data: Base64.encode(binContent[1]), // json
      },
      {
        name: binName + binContent0.source[1],
        data: binContent[2], // 图片base64
      },
      {
        name: binName + binContent0.source[2],
        data: Base64.encode(binContent[3]), // ani
      },
    ]
  }
  throw new Error('图集的依赖应为1或3')
}

export function moveNodeImage({ projectKey, image, targetPath, targetName }) {
  return new Promise((resolve, reject) => {
    const iframeWindow = store.state.workspace.game.iframeWindow
    const qc = store.state.workspace.game.data
    const asset = qc.gameObj.assets.findByUUID(image.uuid)
    const uuid2url = store.state.workspace.game.uuid2url
    const orgPath = image.url
    const orgPathSet = orgPath.split('/')
    const binName = orgPathSet.pop()
    const targetBinPath = targetPath + '/' + targetName + '.bin'
    const metaName = binName + '.meta'
    const orgMetaPath = orgPathSet.join('/') + '/' + metaName
    const targetMetaPath = targetPath + '/' + targetName + '.bin.meta'
    let imgExt = image.src.split('/').pop()
    imgExt = imgExt.split('.').pop()
    let imgName = image.url.split('/').pop()
    const imgNameArray = imgName.split('.')
    imgNameArray.pop()
    imgName = imgNameArray.join('.')
    const orgImgPath = orgPathSet.join('/') + '/' + imgName + '.' + imgExt
    const targetImgPath = targetPath + '/' + targetName + '.' + imgExt
    moveFile({
      pid: projectKey,
      src: orgImgPath,
      dst: targetImgPath,
      overwrite: 1,
    }).then((resA) => {
      moveFile({
        pid: projectKey,
        src: orgPath,
        dst: targetBinPath,
        overwrite: 1,
      }).then((resB) => {
        moveFile({
          pid: projectKey,
          src: orgMetaPath,
          dst: targetMetaPath,
          overwrite: 1,
        }).then((resC) => {
          for (const i in uuid2url) {
            if (uuid2url[i] === targetBinPath) {
              delete uuid2url[i]
              break
            }
          }
          uuid2url[image.uuid] = targetBinPath
          iframeWindow.urlMapConfig = uuid2url
          qc.gameObj.assets._keyUrl[image.uuid] = targetBinPath
          qc.gameObj.assets._keyUrl[targetBinPath] = targetBinPath
          qc.gameObj.assets._assets[targetBinPath] =
            qc.gameObj.assets._assets[orgPath]
          qc.gameObj.assets._assets[targetImgPath] =
            qc.gameObj.assets._assets[orgImgPath] || asset
          if (asset) {
            // asset.key = targetBinPath
            asset.url = targetBinPath
            // asset._data.url = targetBinPath
            asset.img.src = targetImgPath
          }
          saveGlobalUrlMap({ projectKey, uuid2url })
          qc.gameObj.assets.load(
            image.uuid,
            targetBinPath + '?ts=' + Date.now(),
            () => {
              resolve({ targetBinPath, targetImgPath })
            },
            true,
          )
        })
      })
    })
  })
}

export function copyNodeImageToPath({
  projectKey,
  node,
  uuid2url,
  targetPath,
}) {
  const uuid = generateUUID()
  const atlas = node.data.game.assets.findByUUID(node.texture.atlas.uuid)
  const orgPath = atlas.url
  const binName = atlas.url.split('/').pop()
  const atlasMeta = JSON.stringify(atlas.meta)
  readFile({ pid: projectKey, path: orgPath }).then((res) => {
    const data = JSON.parse(res)
    data[0]['uuid'] = uuid
    createComponent({
      name: binName.replace(/\.bin$/, ''),
      icon_data: data[2],
      type: AssetType.ASSET_ATLAS,
      files_data: JSON.stringify([
        // bin
        {
          name: binName,
          data: Base64.encode(JSON.stringify(data)),
        },
        // 原图
        {
          // 非浏览器使用的格式转成合法的 base64
          data: data[2],
          name: binName,
        },
      ]),
      cat_id: 1,
    }).then((res) => {
      console.log(atlasMeta)
    })
  })
}

export function file2lang(file, lang) {
  let before = file // 名称前缀

  const afterIdx = file.lastIndexOf('.')
  let after = '' // 名称后缀
  if (afterIdx !== -1) {
    after = file.slice(afterIdx, file.length)
    before = file.slice(0, afterIdx)
  }
  const beforeIdx = file.indexOf('-')
  if (beforeIdx !== -1) {
    before = file.slice(0, beforeIdx)
  }
  // 当前语言图片资源URL或Key
  return before + '-' + lang + after
}

export function isBuiltinScript(script) {
  let _isBuiltinScript = false
  builtinScript.forEach((bs) => {
    if (bs.class_name === script) {
      // 属于内置脚本
      _isBuiltinScript = true
    }
  })
  return _isBuiltinScript
}

export async function DFS(node, callback) {
  if (callback) {
    await callback(node)
  }
  const children = node.children
  if (node.children.length === 0) {
    return
  }
  for (const i in children) {
    const item = children[i]
    await DFS(item, callback)
  }
}

export function parseBinContent(binContent) {
  const data = JSON.parse(binContent)
  const sourceMeta = JSON.parse(data[0])
  const uuid = sourceMeta.uuid
  const suffix = sourceMeta.source[0]
  const type = sourceMeta.source[0].replace('.', '').toLowerCase()

  return {
    data,
    sourceMeta,
    uuid,
    suffix,
    type,
  }
}

export function parseComponent(res) {
  const type = res.data.type
  const files = res.data.files
  let prefabName = ''
  let prefabMeta = {}
  let prefabBin = null
  if (type === AssetType.ASSET_PREFAB) {
    for (let i = 0, iMax = files.length; i < iMax; i++) {
      if (files[i].name.indexOf('.prefab') > 0) {
        prefabName = files[i].name.substr(0, files[i].name.indexOf('.prefab'))
        break
      }
    }
  } else if (type === AssetType.ASSET_ATLAS) {
    // 图集类型没有.prefab文件
    for (let i = 0, iMax = files.length; i < iMax; i++) {
      if (files[i].name.indexOf('.bin') > 0) {
        // 自己上传的图片是没有meta文件的
        prefabName = files[i].name.substr(0, files[i].name.indexOf('.bin'))
        break
      }
    }
  }
  if (prefabName === '') {
    return { errorMsg: '无法读取模板名字' }
  }
  for (let j = 0, jMax = files.length; j < jMax; j++) {
    if (files[j].name === prefabName + '.bin') {
      prefabBin = JSON.parse(Base64.decode(files[j].data))
    }

    if (files[j].name === prefabName + '.bin.meta') {
      prefabMeta = JSON.parse(Base64.decode(files[j].data))
    }
  }
  const meta = prefabMeta
  const json = JSON.parse(prefabBin[1])
  const prefabBin0 = JSON.parse(prefabBin[0])
  return {
    prefabName,
    meta,
    json,
    files,
    type,
    animationType: prefabBin0.animationType,
    binUuid: prefabBin0.uuid,
  }
}

export function loadScriptOnGameWindow(scripts, win, callback) {
  const length = scripts.length
  if (length === 0) {
    callback && callback()
    return
  }
  let cnt = 0
  scripts.forEach((item) => {
    const scriptDom = win.document.createElement('script')
    scriptDom.setAttribute('type', 'text/javascript')
    scriptDom.src = item
    scriptDom.onload = function () {
      ++cnt
      if (cnt === length) {
        callback && callback()
      }
    }
    win.document.body.appendChild(scriptDom)
  })
}

export function getCurrentPageNode() {
  const qc = store.state.workspace.game.data
  const currentPage = store.state.workspace.game.currentPage
  const world = qc.gameOb.world
  let currentPageName = ''
  if (currentPage === GamePage.GAME) {
    currentPageName = GamePage.GAMEPLAY
  }
  if (currentPage === GamePage.ENDING) {
    currentPageName = GamePage.END_NODE_NAME
  }
  if (currentPage === GamePage.START) {
    currentPageName = GamePage.START_NODE_NAME
  }
  return world.children[0]._findByName(currentPageName)
}

export function getNodesByClass({ item, className }) {
  let res = []
  if (item.children) {
    res = res.concat(item.children.filter((child) => child.class === className))
    item.children.forEach((child) => {
      res = res.concat(getNodesByClass({ item: child, className }))
    })
  }
  return res
}

export function getNodeByUUID({ item, id }) {
  if (item.uuid === id && id !== undefined) {
    return item
  } else if (item.children && item.children.length > 0) {
    for (let i = 0; i < item.children.length; i++) {
      const childItem = item.children[i]
      const tempNode = getNodeByUUID({ item: childItem, id })
      if (tempNode) return tempNode
    }
  } else {
    return null
  }
}

export function getNodeByPath(qc, currentPage, path) {
  let node
  if (currentPage === GamePage.GAME) {
    node = qc.gameOb.world.find(`UIRoot/${GamePage.GAMEPLAY}${path}`)
  } else if (currentPage === GamePage.ENDING) {
    node = qc.gameOb.world.find(`UIRoot/${GamePage.END_NODE_NAME}${path}`)
  } else if (currentPage === GamePage.START) {
    node = qc.gameOb.world.find(`UIRoot/${GamePage.START_NODE_NAME}${path}`)
  }
  return node
}

// 是否交互视频模板
export function isInteractiveVideo(iframeWindow) {
  // let isVideo = iframeWindow.qici.config.isVideo
  // // 以后都是不区分交互视频模板啦
  // isVideo = true
  // return isVideo
  if (!iframeWindow) return false
  if (typeof iframeWindow.qici.config.isMultiScene === 'undefined') {
    return false
  }
  return iframeWindow.qici.config.isMultiScene
}

// 是否EcPlus模板
export function isEcPlus(iframeWindow) {
  if (!iframeWindow) return false
  if (typeof iframeWindow.qici.config.isEcPlus === 'undefined') {
    return false
  }
  return iframeWindow.qici.config.isEcPlus
}

export function getNodePath(node) {
  const nodeArr = []
  while (!isGamePlay(node) && node) {
    if (utils.isScene(node)) {
      nodeArr.push(node.uniqueName)
    } else {
      nodeArr.push(node.name)
    }
    node = node.parent
  }
  nodeArr.reverse()
  return nodeArr.join('/')
}

export function isGamePlay(node) {
  if (node.getScript('ps.VPGamePlay')) {
    return true
  }
  return false
}

export function getRouteIndexByNodeInScene(node) {
  if (!node) {
    // 获取场景的根节点
    return ''
  }
  const nodeArr = []

  if (isGamePlay(node.parent)) {
    return ''
  }
  nodeArr.push(node.parent.getChildIndex(node))
  // 节点在场景中的每层相对路径的childIndex,防止同名节点的问题
  while (node && !isGamePlay(node.parent.parent)) {
    node = node.parent
    if (node) {
      nodeArr.push(node.parent.getChildIndex(node))
    }
  }
  nodeArr.reverse()
  return nodeArr.join('/')
}
// 根据序号索引路径获取场景中的节点
export function findChildByRouteIndexInScene(sceneNode, routeIndex) {
  if (routeIndex === '') {
    return sceneNode
  }
  const routeIndexArr = routeIndex.split('/')
  let node = sceneNode
  routeIndexArr.forEach((index) => {
    node = node.getChildAt(index)
  })
  return node
}

export function DFSForLanguageNodes(node, callback) {
  if (node.class === 'qc.Video' || node.class === 'qc.Sound') {
    return
  }
  callback && callback(node)
  const children = node.children
  if (node.children.length === 0) {
    return
  }
  for (const i in children) {
    const item = children[i]
    DFSForLanguageNodes(item, callback)
  }
}

// 转化颜色：值为：rgba(194, 78, 78, 1) 转化为： #c24e4e
export function getHexColor(color) {
  const values = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',')
  const a = parseFloat(values[3] || 1)
  const r = Math.floor(a * parseInt(values[0], 10) + (1 - a) * 255)
  const g = Math.floor(a * parseInt(values[1], 10) + (1 - a) * 255)
  const b = Math.floor(a * parseInt(values[2], 10) + (1 - a) * 255)
  const result =
    '#' +
    ('0' + r.toString(16)).slice(-2) +
    ('0' + g.toString(16)).slice(-2) +
    ('0' + b.toString(16)).slice(-2)
  return result
}

export function isItalic(node) {
  return text.isItalic(node)
}

// 设定斜体部分后续可能需要用到，这里需要处理qc的bug，就是在节点的enableGlow===true的时候，斜体设置是不生效的，必须先把enableGlow设置为false，然后才能设置，后面还需要还原enableGlow，以及让italic数据再设置一次
export function setItalic(node, italicValue) {
  return text.setItalic(node, italicValue)
}

export function setEnableGlow(node, enableGlowValue) {
  return text.setEnableGlow(node, enableGlowValue)
}

export function getDirectoryByPage() {
  return AssetRoute.GAME_ROOT
}

export function TraversAst(root) {
  let scriptFile = ''
  let func = ''
  let code = ''
  switch (root.node) {
    case 'scene':
      scriptFile = 'SceneVP.js'
      break
    default:
      break
  }
  func = root.condition.type
  if (func === 'onClick') {
    func = 'onClick'
    code = getCode(root.condition.body)
  } else if (func === 'compare') {
    func = 'update'
    code = `if (${root.condition.params[0].value}${root.condition.params[1].value}${root.condition.params[2].value}) {
      `
    code = getCode(root.condition.body)
    code += '}'
  }

  function getCode(body) {
    body.forEach((item) => {
      let params = []
      item.params.forEach((param) => {
        switch (param.type) {
          case 'number':
            params.push(param.value)
            break
          case 'string':
            params.push(`'${param.value}'`)
            break
          case 'function':
            // eslint-disable-next-line
            const f = `function () {
              ${param.value}
            };`
            params.push(f)
            break
          default:
            break
        }
      })
      params = params.join(',')
      code += `${item.node}.${item.action}(${params});
        `
    })
    return code
  }
  return {
    scriptFile,
    code,
    func,
  }
}

// 与js脚本增删改相关的函数
export function reloadScript(
  { projectKey, src, noNeedUpdateVar },
  onloadScript,
) {
  return new Promise((resolve, reject) => {
    const scriptElement = document.querySelector(`script[src='${src}']`)
    const gameWindow =
      store.state.workspace.game.game.container.offsetParent.parentNode
        .parentNode.defaultView
    if (scriptElement) {
      gameWindow.body.removeChild(scriptElement)
    }
    const appendScriptElement = gameWindow.document.createElement('script')
    appendScriptElement.setAttribute('type', 'text/javascript')
    appendScriptElement.src = src
    appendScriptElement.onload = function () {
      resolve(onloadScript && onloadScript())
    }
    gameWindow.document.body.appendChild(appendScriptElement)
    if (noNeedUpdateVar) return
    const iframe = getIframe()
    const qiciScripts = iframe.qici.scripts
    const exsist = qiciScripts.some((script) => {
      if (typeof script === 'string') {
        return script.indexOf(src) > -1
      }
      return false
    })
    if (!exsist) {
      qiciScripts.push(src)
    }
    updateVar({
      params: {
        pid: projectKey,
        name: 'scripts',
      },
      data: JSON.stringify(qiciScripts),
    })
  })
}

export function deleteScript({ projectKey, src }) {
  return new Promise((resolve, reject) => {
    const scriptElement = document.querySelector(`script[src='${src}']`)
    const gameWindow =
      store.state.workspace.game.game.container.offsetParent.parentNode
        .parentNode.defaultView
    if (scriptElement) {
      gameWindow.body.removeChild(scriptElement)
    }
    const qiciScripts = gameWindow.qici.scripts
    const index = qiciScripts.indexOf(src)
    if (index > -1) {
      qiciScripts.splice(index, 1)
    }
    updateVar({
      params: {
        pid: projectKey,
        name: 'scripts',
      },
      data: JSON.stringify(qiciScripts),
    }).then(() => {
      resolve()
    })
  })
}

export async function addPlugin({ projectKey, plugins }) {
  const iframe = getIframe()
  const qiciScripts = iframe.qici.scripts
  const pluginList = qiciScripts.filter(
    (script) => Object.prototype.toString.call(script) === '[object Array]',
  )
  let needUpdateVar = false
  for (const i in plugins) {
    const src = plugins[i][0]
    const exsist = pluginList.some((p) => p[0].indexOf(src) > -1)
    if (exsist) {
      // eslint-disable-next-line no-continue
      continue
    } else {
      qiciScripts.push(plugins[i])
    }
    needUpdateVar = true
    const gameWindow =
      store.state.workspace.game.game.container.offsetParent.parentNode
        .parentNode.defaultView
    const appendScriptElement = gameWindow.document.createElement('script')
    appendScriptElement.setAttribute('type', 'text/javascript')
    appendScriptElement.src = src
    gameWindow.document.body.appendChild(appendScriptElement)
    await new Promise((resolve) => {
      appendScriptElement.onload = function () {
        resolve()
      }
    })
  }
  if (needUpdateVar) {
    updateVar({
      params: {
        pid: projectKey,
        name: 'scripts',
      },
      data: JSON.stringify(qiciScripts),
    })
  }
}
export function deletePlugin({ projectKey, plugins }) {
  const iframe = getIframe()
  const qiciScripts = iframe.qici.scripts
  for (const i in plugins) {
    const src = plugins[i][0]
    // const scriptElement = document.querySelector(`script[src='${src}']`)
    // const gameWindow =
    //   store.state.workspace.game.game.container.offsetParent.parentNode
    //     .parentNode.defaultView
    // if (scriptElement) {
    //   gameWindow.body.removeChild(scriptElement)
    // }
    const index = qiciScripts.findIndex((script) => {
      return (
        Object.prototype.toString.call(script) === '[object Array]' &&
        script[0].indexOf(src) > -1
      )
    })
    if (index > -1) {
      qiciScripts.splice(index, 1)
    }
  }
  updateVar({
    params: {
      pid: projectKey,
      name: 'scripts',
    },
    data: JSON.stringify(qiciScripts),
  })
}

export async function addPluginSetting(plugin) {
  const projectKey = router.currentRoute.query.id
  const path = 'ProjectSetting/plugin.setting'
  const pluginSetting = await readFile({
    pid: projectKey,
    path,
  })
  if (!pluginSetting[plugin]) {
    pluginSetting[plugin] = {}
    const ans = JSON.stringify(pluginSetting, null, 2)
    await saveFile(
      {
        pid: projectKey,
        path,
      },
      ans,
    )
  }
}

export async function deletePluginSetting(plugin) {
  const projectKey = router.currentRoute.query.id
  const path = 'ProjectSetting/plugin.setting'
  const pluginSetting = await readFile({
    pid: projectKey,
    path,
  })
  if (pluginSetting[plugin]) {
    delete pluginSetting[plugin]
    const ans = JSON.stringify(pluginSetting, null, 2)
    await saveFile(
      {
        pid: projectKey,
        path,
      },
      ans,
    )
  }
}

export function qcAssetLoadAsync(uuid, path) {
  return new Promise((resolve, reject) => {
    const game = store.state.workspace.game
    game.data.gameObj.assets.load(
      uuid,
      path,
      (asset) => {
        resolve(asset)
      },
      true,
    )
  })
}

/**
 * 重新加载一个node上的script
 * @param {Object} qcNode
 * @param {String | RegExp} className
 */
export function qcNodeReloadScript(qcNode, className) {
  if (!qcNode || !className) return
  qcNodeRemoveScript(qcNode, className)
  qcNode.addScript(className)
}

/**
 * 递归移除一个node上的所有匹配到className的script
 * @param {Object} qcNode
 * @param {String | RegExp} className
 */
export function qcNodeRemoveScript(qcNode, className) {
  if (!qcNode || !className) return
  const reg = className instanceof RegExp ? className : new RegExp(className)
  const scripts = qcNode.scripts.filter((script) => script.class.match(reg))
  scripts.forEach((item) => {
    qcNode.removeScript(item)
  })
}

/**
 * 判断节点是否龙骨
 * @param {节点} node
 */
export function isDragonBone(node) {
  return utils.isDragonBone(node)
}

/**
 * 判断节点是否龙骨子节点
 * @param {*} node
 */
export function isDragonBoneChild(node) {
  return utils.isDragonBoneChild(node)
}

/**
 * 判断节点是否粒子
 * @param {节点} node
 */
export function isParticleSystem(node) {
  return node.class === 'qc.ParticleSystem'
}

export function getGamePlay() {
  return store.getters['workspace/game/gamePlay']
}

export function ensureScript(node, scriptName) {
  const script = node.getScript(scriptName)
  if (script) return script
  return node.addScript(scriptName)
}

// qcColor转成element UI的color
export function qcColor2elColor(Color) {
  return getHexColor(transformColorFormat(Color))
}

export function isQcColor(color) {
  return color.class === 'qc.Color'
}

export function fmtSize(bytes) {
  if (typeof bytes === 'undefined') {
    return '0B'
  }
  const a = ['B', 'KB', 'MB', 'GB', 'TB']
  let i = 0
  if (Number(bytes) !== 0) {
    while (Number(bytes) >= 1024) {
      bytes /= 1024
      // eslint-disable-next-line no-plusplus
      i++
    }
    const sTemp = Number(bytes).toFixed(2) + a[i]
    return sTemp
  } else if (Number(bytes) === 0) {
    return ''
  }
  return '-'
}

export const getUUID = (path) => {
  const game = store.state.workspace.game
  let uuid = null
  // 用最后的那个uuid
  for (const i in game.uuid2url) {
    if (game.uuid2url[i] === path) {
      uuid = i
    }
  }
  if (uuid) {
    return uuid
  }
  return generateUUID()
}
